import { ValidationErrors } from '@angular/forms';

export class UTMGeokoordinatenValidator {

    public static readonly HOCHWERT_MIN_ZONE_32 = 5200000;
    public static readonly HOCHWERT_MAX_ZONE_32 = 6250000;
    public static readonly HOCHWERT_MIN_ZONE_33 = 5200000;
    public static readonly HOCHWERT_MAX_ZONE_33 = 6250000;

    public static readonly RECHTSWERT_MIN_ZONE_32 = 250000;
    public static readonly RECHTSWERT_MAX_ZONE_32 = 950000;
    public static readonly RECHTSWERT_MIN_ZONE_33 = 250000;
    public static readonly RECHTSWERT_MAX_ZONE_33 = 500000;

    public static readonly ERROR_KEY_HOCHWERT_OUT_OF_BOUNDS = 'tnbUTMHochwertOoB';
    public static readonly ERROR_KEY_RECHTSWERT_OUT_OF_BOUNDS = 'tnbUTMRechtswertOoB';
    public static readonly ERROR_KEY_INVALID_PATTERN = 'tnbUTMInvalidPattern';

    public static readonly UTM_KOORDINATEN_PATTERN = RegExp('^[0-9]+([,.][0-9]{1})?$');

    static validateHochwert(value: number, utmZone: number): ValidationErrors | null {
        return this.validate(value, utmZone, this.HOCHWERT_MIN_ZONE_32, this.HOCHWERT_MAX_ZONE_32, this.HOCHWERT_MIN_ZONE_33,
            this.HOCHWERT_MAX_ZONE_33, this.ERROR_KEY_HOCHWERT_OUT_OF_BOUNDS);
    }

    static validateRechtswert(value: number, utmZone: number): ValidationErrors | null {
        return this.validate(value, utmZone, this.RECHTSWERT_MIN_ZONE_32, this.RECHTSWERT_MAX_ZONE_32, this.RECHTSWERT_MIN_ZONE_33,
            this.RECHTSWERT_MAX_ZONE_33, this.ERROR_KEY_RECHTSWERT_OUT_OF_BOUNDS);
    }

    static validate(value: number, utmZone: number, zone32Min: number, zone32Max: number, zone33Min: number, zone33Max: number,
        errorCode: string): ValidationErrors | null {

        if (value === null || typeof value === 'undefined') {
            return { pattern: true };
        }

        let invalid = false;

        if (!this.UTM_KOORDINATEN_PATTERN.test(value.toString())) {
            invalid = true;
            const validationErrors = {};
            validationErrors[this.ERROR_KEY_INVALID_PATTERN] = true;
            return validationErrors;
        }

        if (utmZone === 32) {
            if (value < zone32Min ||
                value > zone32Max) {
                invalid = true;
            }
        } else if (utmZone === 33) {
            if (value < zone33Min ||
                value > zone33Max) {
                invalid = true;
            }
        } else {
            console.error('Invalid Zone: ' + utmZone + '. Did you forget to pass utmZone?');
        }

        if (invalid) {
            const validationErrors = {};
            validationErrors[errorCode] = true;
            return validationErrors;
        }

        return null;

    }

}
